function consent(text,accept,hide,info,url,age){

	/*get timestamps*/
	var unix = Math.round((new Date()).getTime() / 1000);
	var expire = age*24*60*60;

	/*if not set or deprecated*/
	if(
		(localStorage['policy'] == null) ||
		((localStorage['policy'] != '') && (localStorage['policy'] < unix-expire))
	){

		console.log('tracking prevented');

		/*show notification*/
		$('body').prepend('<div class="policy">'+text+'<div class="box"><a href="'+url+'" target="_blank">'+info+'</a><a class="accept">'+accept+'</a><a class="hide">'+hide+'</a></div></div>');

	}else{
		/*tracking already enabled, so track*/
		track();
	}

	/*accept*/
	$('.accept').click(function(){
		localStorage['policy'] = unix;
		track();
		$('.policy').remove();
	});

	/*hide*/
	$('.hide').click(function(){
		$('.policy').remove();
	});

}


/*tracking*/
var tracking = false;
function gtag(){
	dataLayer.push(arguments);
}
function track(){
	tracking = true;
	console.log('tracking enabled');
	$.getScript( "https://www.googletagmanager.com/gtag/js?id=G-D09PDZDQ7H", function( data, textStatus, jqxhr ) {
		window.dataLayer = window.dataLayer || [];
		gtag('js', new Date());
		gtag('config', 'UA-40015365-1', { 'anonymize_ip': true });
		gtag('config', 'G-D09PDZDQ7H', { 'anonymize_ip': true });
	});
	if (typeof loadMap !== 'undefined' && $.isFunction(loadMap)) {
		loadMap();
	}

}




